import { Box, Stack, Typography } from '@mui/material'

import { TOutreach } from '~/features/campaigns/models'

type TOutreachTextScriptPreviewPayload = {
  outreach: TOutreach
}

export default function OutreachTextScriptPreview({
  outreach,
}: TOutreachTextScriptPreviewPayload) {
  return (
    <Stack>
      {outreach.textScript && (
        <Box>
          <Typography variant="body2">Text message:</Typography>
          <Typography variant="body2">{outreach.textScript}</Typography>
        </Box>
      )}
    </Stack>
  )
}
